import React, { useEffect, useRef } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import ReactPlayer from "react-player";

const TestingSection = () => {
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(function (stream) {
        const videoElement = document.querySelector("video");
        videoElement.srcObject = stream;

        const canvasElement = document.querySelector("canvas");
        const context = canvasElement.getContext("2d");
        context.drawImage(
          videoElement,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
        const imageData = canvasElement.toDataURL("image/jpeg");
        const formData = new FormData();
        formData.append("image", imageData);

        fetch("/upload", {
          method: "POST",
          headers: {
            "Content-Type": "application/octet-stream",
          },
          body: formData,
        })
          .then(function (response) {
            // Handle server response
          })
          .catch(function (error) {
            // Handle error
          });
      })
      .catch(function (error) {
        // Handle permission denied or error
      });
  }, []);

  return (
    <>
      <Box
        sx={{
          mt: 24,
          // background: "grey"
        }}
      >
        <video controls></video>
      </Box>
    </>
  );
};

export { TestingSection };
